import Control from "../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPRODiversBureau = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });
  return (
    <div>
      <Control
        label={inputsConfig.bureauTypeActivite.label}
        type="checkBtnList"
        name="bureauTypeActivite"
        value={company.RCPRO.bureauTypeActivite}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.bureauTypeActivite.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      {company.RCPRO.bureauTypeActivite.includes(4) && (
        <Control
          label={inputsConfig.bureauAutreActivite.label}
          type="text"
          name="bureauAutreActivite"
          value={company.RCPRO.bureauAutreActivite}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <Control
        label={inputsConfig.bureauUtilisationLogiciels.label}
        type="btnList"
        name="bureauUtilisationLogiciels"
        value={company.RCPRO.bureauUtilisationLogiciels}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.bureauUtilisationLogiciels.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPRODiversBureau;
